import StopPaymentsFeedbackPageContainer from './container';

export default StopPaymentsFeedbackPageContainer;
